import React, { useState, useEffect, useMemo } from 'react'
import Select from 'react-select';
import { fetchBrands, fetchTags, fetchPackages, capitalizeFLetter } from '../../../fnc'
import SheetCapture from '../SheetCapture';
const refConst = require("../../../constants.js").v

var initialState = {
	brands: [], // List
	tags: [],
	tagSelected: [],
	packages: [],

	localTagSelected: null,
	localBrandSelected: null,
	localPackageSelected: null,
	_isMounted: false
};

export default function Filter(props){

	var operators = [
		">",
		">=",
		"<",
		"<=",
		"="
	]

	let varToReset = [
		'localTagSelected',
		'localBrandSelected',
		'localPackageSelected',
	];

	const [localTagSelected, setLocalTagSelected] = useState(initialState.localTagSelected);
	const [localBrandSelected, setLocalBrandSelected] = useState(initialState.localBrandSelected);
	const [localPackageSelected, setLocalPackageSelected] = useState(initialState.localPackageSelected);
	
	const [tags, setTags] = useState(initialState.tags.slice(0));
	const [brands, setBrands] = useState(initialState.brands.slice(0));
	const [packages, setPackages] = useState(initialState.packages.slice(0));

	useEffect(() => {
		initialState._isMounted = true;

		fetchBrands(refConst.id_store_finale, {}, null, (r) => {
			if(!initialState._isMounted)	return false
			console.log("Fetched_brands_for " + refConst.id_store_finale, r);

			if(r.success){
				let results = r.data
				let listBrandNames = [];
				results.forEach(b => {
					listBrandNames.push(b.name)
				})
				setBrands(listBrandNames)
				/* fetchShopifyBrands(null, {}, null, (rShopify) => {
					if(!initialState._isMounted)	return false
					console.log("Fetched_brands_for2 " + refConst.id_store_finale, rShopify);
					if(rShopify.success){
						setBrands([...listBrandNames, ...rShopify.data])
					}
				}) */
			}
		})

		fetchTags(null, null, (r) => {
			if(!initialState._isMounted)	return false
			console.log("Fetched tags for " + refConst.id_store_finale, r);
			if(r.success){
				let results = r.data
				setTags(results)
			}
		})
		fetchPackages(null, (r) => {
			if(!initialState._isMounted)	return false
			console.log("Fetched packages for " + refConst.id_store_finale, r);
			if(r.success){
				let results = r.data
				setPackages(results)
			}
		})
		return () => initialState._isMounted = false
	}, [])

	const resetForm = (r) => {
		varToReset.map(v => {
			console.info('Eval result', eval("set" + capitalizeFLetter(v))( JSON.parse(JSON.stringify(initialState[v])) ));
		})
	}

	useEffect(() => {
		if(!props.vari.vendorSelected && initialState._isMounted) setLocalBrandSelected(initialState.localBrandSelected)
	}, [props.vari.vendorSelected])

	var randomId = Math.random();
	var rightCtnEnabled = props.rightCtn? true : false
	const searchRef = props.search || props.sku;
	const showCostFilter = props.cost && props.operatorCost;
	const showActiveFilter = props.active;
	const showSheetCapture = props.setStateSafe && props.dataSheet !== undefined;

	const selectStyles = useMemo(() => ({
		...refConst.styleList,
		container: (provided, state) => ({
			...(refConst.styleList.container ? refConst.styleList.container(provided, state) : provided),
			minWidth: "100%",
			width: "100%"
		}),
		control: (provided, state) => ({
			...(refConst.styleList.control ? refConst.styleList.control(provided, state) : provided),
			borderColor: state.isFocused ? "#2563eb" : "#b8c4d3",
			borderRadius: "5px",
			boxShadow: state.isFocused ? "0 0 0 3px rgba(37, 99, 235, 0.12)" : "none",
			minHeight: "44px",
			"&:hover": {
				borderColor: "#2563eb"
			}
		}),
		menu: (provided, state) => ({
			...(refConst.styleList.menu ? refConst.styleList.menu(provided, state) : provided),
			borderRadius: "5px",
			overflow: "hidden"
		})
	}), []);

	const brandOptions = useMemo(() => brands.map(brand => ({
		value: brand,
		label: `${brand}`
	})), [brands]);

	const tagOptions = useMemo(() => tags.map(t => ({
		value: t,
		label: t
	})), [tags]);

	const packageOptions = useMemo(() => packages.map(t => ({
		value: t.id,
		label: `[${t.carrier_name}] ${t.name}`
	})), [packages]);

	const submitFilter = (e) => {
		e.preventDefault()

		if(props.setStateSafe){
			props.setStateSafe({
				'current_page': 1,
				'brandSelected': localBrandSelected,
				'tagSelected': localTagSelected? localTagSelected.value : localTagSelected,
				'packageSelected': localPackageSelected
			}, () => {
				if(props.onUpdateItem) props.onUpdateItem()
			})
			return;
		}

		if(props.onUpdateItem) props.onUpdateItem(e)
	}

	const clearFilter = () => {
		resetForm()
		if(props.onClearResult) props.onClearResult()
	}
	
	return (
		<div className={(rightCtnEnabled? "eio-filter-shell--with-side " : "") + "eio-filter-shell"}>
			<form ref={props.formFilter} className="eio-filter-card" onSubmit={submitFilter}>
				<div className="eio-filter-header">
					<div>
						<p className="eio-filter-eyebrow">search center</p>
						<h2 className="eio-filter-title">Inventory filters</h2>
					</div>
					<div className="eio-filter-header-actions">
						{showActiveFilter? <div className="custom-control custom-switch eio-filter-switch">
							<input type="checkbox" className="custom-control-input" id="customSwitchActive" defaultChecked={true} ref={props.active}/>
							<label className="custom-control-label noselect pointer" htmlFor="customSwitchActive">Active only</label>
						</div> : ''}
					</div>
				</div>

				<div className="eio-filter-grid">
					<div className="eio-filter-field eio-filter-field--wide">
						<label>Search</label>
						<input type="text" ref={searchRef} className="form-control eio-filter-control" placeholder="SKU, title, or vendor" aria-label="Search inventory"></input>
					</div>

					<div className="eio-filter-field">
						<label>Started at</label>
						<input type="date" ref={props.startAt} onChange={props.submitSearch} className="form-control eio-filter-control" placeholder="Start at" aria-label="Start at"></input>
					</div>

					<div className="eio-filter-field">
						<label>Quantity on hand</label>
						<div className="eio-filter-combo">
							<select ref={props.operatorQtyOnHand} className="custom-select" id={"inputGroupSelectQty" + randomId} aria-label="Quantity operator">
								{
									operators.map((operator) => {
										return <option key={operator} value={operator}>{operator}</option>
									})
								}
							</select>
							<input type="number" min="0" ref={props.qtyOnHand} className="form-control" placeholder="Qty" aria-label="Quantity on hand"/>
						</div>
					</div>

					{showCostFilter? <div className="eio-filter-field">
						<label>Cost</label>
						<div className="eio-filter-combo">
							<select ref={props.operatorCost} className="custom-select" id={"inputGroupSelectCost" + randomId} aria-label="Cost operator">
								{
									operators.map((operator) => {
										return <option key={operator} value={operator}>{operator}</option>
									})
								}
							</select>
							<input type="number" min="0" ref={props.cost} className="form-control" placeholder="Cost" aria-label="Cost"/>
						</div>
					</div> : ''}

					<div className="eio-filter-field">
						<label>Brand</label>
						<Select
							isClearable
							styles={selectStyles}
							onChange={(selectedOption) => {
								setLocalBrandSelected(selectedOption? selectedOption.value : initialState.localBrandSelected)
							}}
							options={brandOptions}
							value={localBrandSelected? {value: localBrandSelected, label: localBrandSelected} : null}
							placeholder={"Select brand"}
							isSearchable={true}
							isMulti={false}
						/>
					</div>

					<div className="eio-filter-field">
						<label>Shopify tag</label>
						<Select
							isClearable
							styles={selectStyles}
							onChange={(selectedOption) => {
								setLocalTagSelected(selectedOption? selectedOption : initialState.localTagSelected)
							}}
							options={tagOptions}
							value={localTagSelected? localTagSelected : null}
							placeholder={"Select tag"}
							isSearchable={true}
							isMulti={false}
						/>
					</div>

					<div className="eio-filter-field">
						<label>Package</label>
						<Select
							isClearable
							styles={selectStyles}
							onChange={(selectedOption) => {
								setLocalPackageSelected(selectedOption? selectedOption : initialState.localPackageSelected)
							}}
							options={packageOptions}
							value={localPackageSelected? {value: localPackageSelected.value, label: localPackageSelected.label} : null}
							placeholder={"Select package"}
							isSearchable={true}
							isMulti={false}
						/>
					</div>
				</div>

				<div className="eio-filter-footer">
					<div className="eio-filter-sheet">
						{showSheetCapture? <SheetCapture className={"mr-0"} dataSheet={props.dataSheet} onChange={(val) => {
							props.setStateSafe({"dataSheet": val})
						}} name={"From Sheet"} {...props} required={['sku']}/> : ''}
					</div>
					<div className="eio-filter-actions">
						<button type="reset" onClick={clearFilter} className="btn eio-filter-btn eio-filter-btn--secondary">Reset</button>
						<button type="submit" className="btn eio-filter-btn eio-filter-btn--primary">Apply filters</button>
					</div>
				</div>
			</form>
			{
				rightCtnEnabled? <div className="eio-filter-side flex-fill">
					{ props.rightCtn }
				</div> : ''
			}
		</div>
	);
}

